import { apiConfig } from '../apiConfig';
import { addCommonHeaders, handleResponse, handleErrors } from '../apiUtils';

export default {
    index: async (missionId, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_events/";

        try {
            const response = await fetch(url, {
                method: "GET",
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },


    // destroy: async (missionId, requirementId, handleRedirect = null) => {
    //     const url = apiConfig.apiUrl + "missions/" + missionId + "/requirements/" + requirementId;

    //     try {
    //         const response = await fetch(url, {
    //             method: "DELETE",
    //             headers: addCommonHeaders(),
    //             credentials: 'include',
    //         })

    //         return await handleResponse(response, handleRedirect);

    //     } catch (error) {
    //         return handleErrors(error);
    //     }
    // },

    update: async (missionId, timezone, notice, buffer, availabilities, handleRedirect = null) => {
        const url = apiConfig.apiUrl + "missions/" + missionId + "/mission_events/create_or_update";

        const body = JSON.stringify({
            mission_event: {
                timezone: timezone,
                minimum_booking_notice_in_milliseconds: notice,
                buffer_length_in_milliseconds: buffer,
            },
            mission_event_availabilities: availabilities,
        });

        try {
            const response = await fetch(url, {
                method: "POST",
                body: body,
                headers: addCommonHeaders(),
                credentials: 'include',
            })

            return await handleResponse(response, handleRedirect);

        } catch (error) {
            return handleErrors(error);
        }
    },

}